// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--m7KUB"};